import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import request from "../../../../Helpers/API";

// Agrega un comentario nuevo al historial de una visita ya realizada — no modifica el
// comentario original de cuando se marcó como realizada. Conectado a
// VisitasCRM/GuardarComentariosVisitas (AgregarComentarioVisita).
export const VisitasModalComentario = ({ open, visita, onClose }) => {
  const [comentario, setComentario] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (open) setComentario("");
  }, [open]);

  if (!visita) return null;

  const handleGuardar = () => {
    if (!comentario.trim()) {
      Swal.fire("VISITAS", "Captura un comentario", "warning");
      return;
    }

    const body = {
      id_visita: visita.id_visita,
      comentario,
    };

    setGuardando(true);
    request
      .post("VisitasCRM/GuardarComentariosVisitas", body)
      .then(async () => {
        setGuardando(false);
        await Swal.fire("VISITAS", "Comentario agregado con éxito", "success");
        onClose(true);
      })
      .catch((error) => {
        setGuardando(false);
        Swal.fire("VISITAS", JSON.stringify(error), "error");
      });
  };

  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <div className="crm-modal-card">
        <button type="button" className="crm-modal-cerrar" onClick={() => onClose(false)}>
          <CloseIcon fontSize="small" />
        </button>

        <h3 className="crm-modal-titulo">Agregar comentario · {visita.razon_social}</h3>

        <div className="crm-modal-body">
          <div className="crm-field">
            <label>Comentario</label>
            <textarea
              className="crm-field-editable crm-modal-textarea"
              rows={4}
              placeholder="Nuevo comentario sobre la visita..."
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </div>
        </div>

        <div className="crm-modal-buttons">
          <button type="button" className="btn-secundario-outline" onClick={() => onClose(false)}>Cancelar</button>
          <button type="button" className="btn-primario-solido" onClick={handleGuardar} disabled={guardando}>Agregar comentario</button>
        </div>
      </div>
    </Modal>
  );
};
